//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { QUploader } from "quasar";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import { getDynamicEnv } from "@/assets/js/appFunc";
import deleteHover from "@/assets/images/Buttons/deleteHover.svg";
import deleteS from "@/assets/images/Buttons/deleteS.svg";

export default {
    name: "AQUploader",
    filters: {
        fileSize(bytes) {
            const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
            const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
            return `${Math.round(bytes / 1024 ** i, 2)} ${sizes[i]}`;
        }
    },
    components: {
        QUploader,
        AQButton,
        AQTooltip
    },
    props: {
        url: { type: String, default: "" },
        filter: { type: Function },
        multiple: { type: Boolean, default: false },
        atId: { type: String, default: "" },
        isMultiple: { type: Boolean, default: false },
        allowedExtensions: { type: String, default: "", required: false },
        smallType: { type: Boolean, default: false },
        disable: { type: Boolean, default: false },
        readonly: { type: Boolean, default: false },
        disabledDelete: { type: Boolean, default: false },
        dataToUpload: { type: Array, default: () => [] },
        showSmallTypeBtn: { type: Boolean, default: false },
        uploadTitle: { type: String, default() { return this.$t("uploader.defaultTitle"); } },
        smallTypeTitle: { type: String, default() { return this.$t("uploader.uploadTitle"); } },
        errorStyle: { type: Boolean, default: false },
        actionBtnLabel: { type: String, default() { return this.$t("apps.dialogTitle"); } },
        customError: { type: String, default: "" },
        isLoading: { type: Boolean, default: false },
        envVariable: { type: String, default: "", required: true },
        noFileUploadedError: { type: Boolean, default: false },
        displayOnlyInfo: { type: Object, default: () => {} }
    },
    data() {
        return {
            uploadedData: [],
            rawFiles: [],
            openTriggerElem: null,
            updateButtonDisabled: false,
            currentLang: "en",
            hovered: null,
            deleteIconNormal: deleteS,
            deleteIconHover: deleteHover
        };
    },
    computed: {
        computedExtensions() {
            return this.allowedExtensions ? this.allowedExtensions.split(",").map(ext => ext.trim()) : [];
        },
        ignoredFiles() {
            return this.uploadedData.filter((item) => this.hasError(item));
        },
        cleanDataList() {
            return this.uploadedData.filter((item) => !this.hasError(item));
        },
        showMaxSize() {
            return getDynamicEnv(this.envVariable);
        },
        isDisplayInfo() {
            return this.displayOnlyInfo && this.displayOnlyInfo.filename && !this.displayOnlyInfo.isUploaded;
        }
    },
    watch: {
        dataToUpload: {
            handler(val) {
                if (val && val.length) {
                    this.uploadedData = val;
                }
            },
            immediate: true
        }
    },
    mounted() {
        this.currentLang = localStorage.getItem("language") || "en";
    },
    methods: {
        setIconColor(item) {
            let color = "";
            if (this.isLoading) {
                color = "grey";
            } else if (this.uploadedData.length && this.hasError(item)) {
                color = "red";
            } else {
                color = "primary";
            }
            return color;
        },
        setIconName(item) {
            let name = "";
            if (this.isLoading) {
                name = "sync";
            } else if (this.uploadedData.length && this.hasError(item)) {
                name = "remove_circle";
            } else {
                name = "check_circle";
            }
            return name;
        },
        onCustomQUploaderTrigger(event) {
            const trigger = this.getQUploaderTrigger();
            if (trigger && event.target !== trigger) {
                this.$refs.qUploader.pickFiles();
            }
        },
        getQUploaderTrigger() {
            const qUploader = document.querySelector(".q-uploader");
            if (qUploader) {
                return qUploader.querySelector(".q-btn");
            }
            return null;
        },
        uploadFile() {
            this.rawFiles = [...this.rawFiles, ...this.$refs.qUploader.files];
            this.checkFiles();
            const dataToSent = this.cleanDataList.map(item => item.file);
            this.$emit("added", dataToSent);
            this.$emit("uploadedData", this.uploadedData);
            this.$refs.qUploader.reset();
        },
        removeFile(item, idx) {
            if (!this.disabledDelete) {
                this.rawFiles.splice(idx, 1);
                this.checkFiles();
                this.updateButtonDisabled = false;
                this.$emit("removeFile", this.uploadedData);
            }
        },
        removeDisplayOnly() {
            if (!this.disabledDelete) {
                this.$emit("removeFile");
            }
        },
        hasError(file) {
            const error = file.errorSize || file.totalSizeErr || file.extensionsErr || file.duplicatedName || this.customError;
            this.$emit("hasErrors", !!error);
            return error;
        },
        checkFiles() {
            this.uploadedData = [];
            let totalFilesSize = 0;
            this.rawFiles.forEach((theFile) => {
                const duplicatedName = !!this.uploadedData.find(
                    elem => elem.file.name === theFile.name
                );
                const errorSize = theFile.size > this.showMaxSize.bytesSize;
                totalFilesSize += theFile.size;
                this.uploadedData.push({
                    file: theFile,
                    duplicatedName: duplicatedName && this.$t("uploader.duplicatedNameErr"),
                    errorSize: errorSize && this.$t("uploader.fileSizeError"),
                    totalSizeErr: (totalFilesSize > this.showMaxSize.bytesSize) && this.$t("uploader.fileSizeError"),
                    extensionsErr: this.checkExtensions(theFile.name) && this.$t("uploader.extensionError")
                });
            });
        },
        checkExtensions(fileName) {
            return this.allowedExtensions ? !this.computedExtensions.some(ext => fileName.endsWith(ext)) : false;
        },
        uploadAction() {
            this.updateButtonDisabled = true;
            this.$emit("uploadAction");
        },
        rejectedFiles(ev) {
            this.$emit("rejected", ev);
        },
        removedFiles(ev) {
            this.$emit("removed", ev);
        },
        uploadingFile(ev) {
            this.$emit("uploading", ev);
        },
        uploadedFile(ev) {
            this.$emit("uploaded", ev);
        },
        failedUploaded(ev) {
            this.$emit("failed", ev);
        },
        startUploading(ev) {
            this.$emit("start", ev);
        },
        finishUploading(ev) {
            this.$emit("finish", ev);
        }
    }
};
